import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import thunkActions from '../store/actions/thunkActions';
import IParams from '../../gqlCustomise/model/IParams';

const useVariantList = () => {
  const dispatch = useDispatch();
  const { modelId } = useParams<IParams>();

  useEffect(() => {
    dispatch(thunkActions.fetchVariantsList(modelId));
  }, [modelId]);
};

export default useVariantList;
